import { Box } from '@mui/material';
import { V2ThemeProvider } from '@onevision-resources/design-theme';
import { NamedLayoutBlock } from 'src/components';
import { BlockedEmailsTable } from './blocked-contacts-table';

export const BlockedContactsView = () => {
  return (
    <NamedLayoutBlock
      BlockContentProps={{
        sx: {
          overflow: 'hidden',
          height: '100vh',
        },
      }}
      title="Blocked Contacts"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      <Box>
        <V2ThemeProvider>
          <BlockedEmailsTable />
        </V2ThemeProvider>
      </Box>
    </NamedLayoutBlock>
  );
};
